module.exports = "<input *ngIf=\"!printing\" type=\"button\" class=\"btn btn-secondary\" (click)=\"print()\" value=\"Download PDF\" />\n<input *ngIf=\"printing\" type=\"button\" class=\"btn btn-secondary\" disabled value=\"Generating PDF...\" />"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/pdf-generate-btn/pdf-generate-btn.component.html
// module id = ./src/app/shared/pdf-generate-btn/pdf-generate-btn.component.html
// module chunks = main